import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import Layout from '../../hoc/Layout/Layout';
import { IUser } from '../../models/states';
import AgentManagement from '../AgentManagement/AgentManagement';
import ScreenManagement from '../ScreenManagement/ScreenManagement';
import SwitcherUI from '../SwitcherUI';
import UserManagement from '../UserManagement/UserManagement';

interface IProtectedRoutesStateProps {
  isAuthenticated: boolean;
  user: IUser;
}
class ProtectedRoutes extends React.Component<IProtectedRoutesStateProps, {}> {
  render() {
    return (
      <React.Fragment>
        <Switch>
          <Route path="/users" exact>
            <Layout renderedComponent={<UserManagement />} />
          </Route>
          <Route path="/screens" exact>
            <Layout renderedComponent={<ScreenManagement />} />
          </Route>
          <Route path="/agents" exact>
            <Layout renderedComponent={<AgentManagement />} />
          </Route>
          <Route path="/switcher/:switcher_name?" exact>
            <Layout renderedComponent={<SwitcherUI />} />
          </Route>
          <Route path="/">
            <Layout renderedComponent={null} />
          </Route>
        </Switch>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    isAuthenticated: state.user.token.length !== 0,
    user: state.user.userInfo
  };
};
export default connect(mapStateToProps, null)(ProtectedRoutes);
